'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { cn } from '../../../../../shared/cn';
import { Button } from '../../../../actions/Button';
interface FullscreenWrapperProps {
  children: React.ReactElement<{
    height?: number;
  }>;
  singleView?: boolean;
  markdownOnly?: boolean;
}
export const FullscreenWrapper: React.FC<FullscreenWrapperProps> = t0 => {
  const $ = _c(23);
  const {
    children,
    singleView: t1,
    markdownOnly: t2
  } = t0;
  const singleView = t1 === undefined ? false : t1;
  const markdownOnly = t2 === undefined ? false : t2;
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [editorHeightRem, setEditorHeightRem] = useState(null);
  const scrollYRef = React.useRef(0);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const updateHeight = () => {
        const windowHeightPx = window.innerHeight;
        const remHeight = windowHeightPx / 16;
        setEditorHeightRem(remHeight - 6);
      };
      updateHeight();
      window.addEventListener("resize", updateHeight);
      return () => window.removeEventListener("resize", updateHeight);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const syncEditorHeightWithWindow = t3;
  const lockBodyScrollForFullscreen = _temp;
  let t4;
  let t5;
  if ($[1] !== isFullscreen) {
    t4 = () => {
      if (!isFullscreen) {
        return;
      }
      return syncEditorHeightWithWindow();
    };
    t5 = [isFullscreen];
    $[1] = isFullscreen;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[4] !== isFullscreen) {
    t6 = () => {
      if (!isFullscreen) {
        return;
      }
      return lockBodyScrollForFullscreen();
    };
    t7 = [isFullscreen];
    $[4] = isFullscreen;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  useEffect(t6, t7);
  const t8 = singleView ? "left-4" : "right-2";
  let t9;
  if ($[7] !== t8) {
    t9 = cn("absolute top-2 z-10", t8);
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      scrollYRef.current = window.scrollY;
      setIsFullscreen(true);
      window.scrollTo(0, 0);
    };
    t11 = <ArrowsPointingOutIcon />;
    $[9] = t10;
    $[10] = t11;
  } else {
    t10 = $[9];
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t9) {
    t12 = <Button outline={true} size="sm" className={t9} onClick={t10}>{t11}</Button>;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== children || $[14] !== editorHeightRem || $[15] !== isFullscreen || $[16] !== markdownOnly || $[17] !== singleView) {
    t13 = isFullscreen && <main className="custom-scrollbar fixed top-14 right-0 bottom-0 left-0 z-10 mx-auto mt-2 flex max-w-[2000px] items-start justify-center overflow-y-auto bg-backgroundSecondary px-6"><Button outline={true} size="sm" className={cn("absolute top-2 z-20", singleView ? "left-9" : "right-8")} onClick={() => {
        setIsFullscreen(false);
        window.scrollTo(0, scrollYRef.current);
      }}><ArrowsPointingInIcon /></Button><section className={cn("h-full w-full", !markdownOnly && "mb-60")}><div className="w-full" style={{
          height: editorHeightRem ? `${editorHeightRem}rem` : "auto"
        }}>{React.isValidElement(children) ? React.cloneElement(children, {
            height: editorHeightRem ?? undefined
          }) : children}</div></section></main>;
    $[13] = children;
    $[14] = editorHeightRem;
    $[15] = isFullscreen;
    $[16] = markdownOnly;
    $[17] = singleView;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== children || $[20] !== t12 || $[21] !== t13) {
    t14 = <div data-slot="control" className="relative w-full">{t12}{children}{t13}</div>;
    $[19] = children;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};
function _temp() {
  const originalOverflow = document.body.style.overflow;
  const originalPaddingRight = document.body.style.paddingRight;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = "hidden";
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
  return () => {
    document.body.style.overflow = originalOverflow;
    document.body.style.paddingRight = originalPaddingRight;
  };
}